import { Injectable } from '@nestjs/common';
import { GrnItemDefects } from '../grn-item-defects.entity';
import { GrnItems } from '../raw-material-grn-items.entity';
import { Grn } from '../raw-material-grn.entity';
import { GrnDTO } from './raw-material-grn.dto';
import { RmGrnDetailsDto } from './rm-grn-details.dto';

@Injectable()
export class GrnAdapter {
  /**
   * 
   * @param grnDto 
   * @param isUpdate 
   * @returns 
   */
  public convertDtoToEntity(grnDto: RmGrnDetailsDto, isUpdate: boolean = false, toDate: any, refNo: any, totalGrnItems: number): Grn {
    const grn = new Grn();
    if (grnDto.grnId) {
      grn.grnId = grnDto.grnId;
    }
    grn.grnDate = grnDto.grnDate;
    grn.indentId = grnDto.indentId;

    grn.supplierType = grnDto.supplierType;
    
    if (grnDto.plantId) {
      grn.plantId = grnDto.plantId;
    }
    if (grnDto.subPlantId) {
      grn.subPlantId = grnDto.subPlantId;
    }else{
      grn.subPlantId = 0;

    }
    
    if (isUpdate) {
      grn.updatedUser = grnDto.updatedUser;
      
    } else {
      grn.isActive = true;
      grn.createdUser = grnDto.createdUser;
      grn.grnNumber = grnDto.grnNumber;
      // grn.lotNumber=grnDto.lotNumber;need to add lot number generation
    }
    const grnItemsData = [];
    for (const grnItem of grnDto.grnItemsInfo) {
      const grnItemObj = new GrnItems()
      // if(grnItem.grnItemId > 0){
      //   grnItemObj.grnItemId = grnItem.grnItemId;
      //   grnItemObj.grnInfo = new Grn();
      //   grnItemObj.grnInfo.grnId = grnItem.grnId;
      // }
      if (grnItem.saleOrderId) {
        grnItemObj.saleOrderId = grnItem.saleOrderId;
      }
      if (grnItem.saleOrderItemId) {
        grnItemObj.saleOrderItemId = grnItem.saleOrderItemId;
      }
      if (isUpdate) {
        grnItemObj.grnItemId = grnItem.grnItemId;
        grnItemObj.grnInfo = new Grn();
        grnItemObj.grnInfo.grnId = grnItem.grnId;
        grnItemObj.updatedUser = grnItem.updatedUser;
        if (grnItem.price) {
          grnItemObj.price = grnItem.price;
        }

      } else {
        grnItemObj.createdUser = grnItem.createdUser;
      }
      grnItemObj.farmer = grnItem.farmer;
      grnItemObj.product = grnItem.product;
      grnItemObj.indentId = grnDto.indentId;
      grnItemObj.farmerCode = grnItem.farmId;
      grnItemObj.quantity = grnItem.quantity;
      grnItemObj.indentItemId = grnItem.indentItemId;
      grnItemObj.count = grnItem.count;
      grnItemObj.softPercentage = grnItem.softPercentage;
      grnItemObj.looseShell = grnItem.looseShell;
      grnItemObj.fungusPercentage = grnItem.fungusPercentage;
      grnItemObj.remarks = grnItem.remarks
      // let grnItemRefNo
      // if(!isUpdate){
      //   let today = new Date();
      //   grnItemRefNo = totalGrnItems + "";
      //   while (grnItemRefNo.length < 4) grnItemRefNo = "0" + grnItemRefNo;
      //   console.log('itemssss');
      //   console.log(grnItemRefNo)
      //   const lotNo = "LOT" + "-" + (grnDto.plantId === 1 ? 'U1' : grnDto.plantId === 2 ? 'U2' : grnDto.plantId === 3 ? 'KKD' : '') + "/" + (toDate.toString().substr(-2)) + '/' + (today.getMonth() + 1) + "/" + grnItemRefNo;
      //     // grnDto.lotNumber = lotNo;
      //   grnItemObj.lotNumber=lotNo;
      // }
      grnItemObj.monthlyRefNo = grnItem.monthlyRefNo
      grnItemObj.boxes = grnItem.boxes;
      if (grnItem.receivedBoxes) {
        grnItemObj.receivedBoxes = grnItem.receivedBoxes;
      }
      const grnItemDefects = []
      if(grnItem.grnItemDefects != undefined){
        for (const grnItemDefect of grnItem.grnItemDefects) {

          const grnDefectObj = new GrnItemDefects()
          grnDefectObj.defectId = grnItemDefect.defectId
          grnDefectObj.percentage = grnItemDefect.percentage
          grnDefectObj.indentId = grnItemDefect.indentId
          grnDefectObj.percentage = grnItemDefect.percentage
          grnDefectObj.indentItemId = grnItem.indentItemId
          grnItemDefects.push(grnDefectObj)
        }
        grnItemObj.grnItemDefects = grnItemDefects;
      }
      else{
        grnItemObj.grnItemDefects = grnItemDefects;
      }
      grnItemsData.push(grnItemObj)
      totalGrnItems = totalGrnItems + 1;

    }
    grn.grnItemsInfo = grnItemsData

    return grn;
  }
  public convertEntityToDto(grnObject: Grn): GrnDTO {
    const grnDto = new GrnDTO;
    grnDto.grnId = grnObject.grnId;
    grnDto.grnDate = grnObject.grnDate;
    grnDto.indentId = grnObject.indentId;
    grnDto.grnNumber = grnObject.grnNumber;
    // grnDto.lotNumber=grnObject.lotNumber;
    // grnDto.saleOrderId=grnObject.saleOrderId;
    // grnDto.saleOrderItemId=grnObject.saleOrderItemId;
    grnDto.supplierType = grnObject.supplierType;
    // grnDto.farmer=grnObject.farmer;
    // grnDto.farmerCode=grnObject.farmerCode;
    // grnDto.quantity=grnObject.quantity;
    // grnDto.count=grnObject.count;
    // grnDto.price=grnObject.price;
    // grnDto.softPercentage=grnObject.softPercentage;
    // grnDto.boxes=grnObject.boxes;
    grnDto.plantId = grnObject.plantId;
    grnDto.subPlantId = grnObject.subPlantId;
    grnDto.isActive = grnObject.isActive;
    grnDto.createdAt = grnObject.createdAt;
    grnDto.updatedAt = grnObject.updatedAt;
    grnDto.createdUser = grnObject.createdUser;
    grnDto.updatedUser = grnObject.updatedUser;
    grnDto.versionFlag = grnObject.versionFlag;
    // grnDto.receivedBoxes = grnObject.receivedBoxes;
    return grnDto;
  }
}
